import { IconType, SvgIcon } from './SvgIcon';

export const PhoneIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 5 30 20">
    <g clipPath="url(#clip0_1205_38175)">
      <path
        d="M6.14299 17.7932L4.41562 15.986C4.25458 15.8188 4.13023 15.6199 4.05051 15.402C3.9708 15.184 3.93748 14.9518 3.95271 14.7202C3.96793 14.4886 4.03135 14.2628 4.13891 14.0571C4.24647 13.8514 4.3958 13.6705 4.57733 13.5259C6.6236 11.9555 9.0097 10.887 11.5439 10.4063C13.8835 9.94 16.297 9.99456 18.6132 10.5661C21.1334 11.1646 23.4772 12.3483 25.4547 14.0214C25.629 14.1736 25.7696 14.3604 25.8678 14.57C25.9659 14.7795 26.0193 15.0072 26.0246 15.2385C26.0299 15.4699 25.987 15.6998 25.8986 15.9136C25.8102 16.1274 25.6782 16.3205 25.5111 16.4805L23.7038 18.2079C23.4142 18.4902 23.0318 18.6576 22.6279 18.6788C22.2241 18.7 21.8262 18.5737 21.5086 18.3233C20.8795 17.8178 20.1953 17.3852 19.469 17.0335C19.1818 16.8954 18.9403 16.6778 18.773 16.4066C18.6057 16.1354 18.5197 15.8219 18.5251 15.5033L18.559 14.007C16.2599 13.3185 13.8175 13.2633 11.4897 13.8472L11.4559 15.3435C11.4469 15.662 11.3468 15.9713 11.1674 16.2347C10.9881 16.4981 10.737 16.7045 10.4439 16.8295C9.70237 17.148 8.99928 17.5493 8.348 18.0258C8.01591 18.2642 7.60777 18.3722 7.20121 18.3294C6.79466 18.2865 6.41804 18.0957 6.14299 17.7932Z"
        stroke="currentColor"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1205_38175">
        <rect
          width="20"
          height="20"
          fill="none"
          transform="translate(29.1387 15.3193) rotate(136.295)"
        />
      </clipPath>
    </defs>
  </SvgIcon>
);

PhoneIcon.displayName = 'PhoneIcon';
